import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchPageContent } from "../api/contentApi";
import { useLang } from "../context/LangContext";
import HeroSection from "./main_hero.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faScaleBalanced, faFilePen, faLanguage, faHandHoldingHand } from "@fortawesome/free-solid-svg-icons";
import "../styles/main_page.css";

export default function MainPage() {
  const [content, setContent] = useState({});
  const { lang } = useLang();

  const navigate = useNavigate();


  useEffect(() => {
    fetchPageContent("main", lang).then(data => setContent(data));
  }, [lang]);

  if (!content) return <p>Loading...</p>;
  return (
  <section>
    <div className="main-hero-section"><HeroSection/></div>
     {content.about_text_1 && (
        <p className="main-text-subtitle">{content.about_text_1}</p>
      )}

      <div className="about-texts-container">
        {content.about_text_2 && (
          <div
            className="about-card"
            onClick={() => navigate("/finance")}
            role="button"
          >
            <div className="about-card-icon">
              <FontAwesomeIcon icon={faFilePen} />
            </div>
            <p>{content.about_text_2}</p>
          </div>
        )}

        {content.about_text_3 && (
          <div
            className="about-card"
            onClick={() => navigate("/finance")}
            role="button"
          >
            <div className="about-card-icon">
              <FontAwesomeIcon icon={faScaleBalanced} />
            </div>
            <p>{content.about_text_3}</p>
          </div>
        )}

        {content.about_text_4 && (
          <div
            className="about-card"
            onClick={() => navigate("/translation")}
            role="button"
          >
            <div className="about-card-icon">
              <FontAwesomeIcon icon={faHandHoldingHand} />
            </div>
            <p>{content.about_text_4}</p>
          </div>
        )}

        {content.about_text_5 && (
          <div
            className="about-card"
            onClick={() => navigate("/translation")}
            role="button"
          >
            <div className="about-card-icon">
              <FontAwesomeIcon icon={faLanguage} />
            </div>
            <p>{content.about_text_5}</p>
          </div>
        )}

        {content.about_text_6 && (
          <div className="about-card">
            <p>{content.about_text_6}</p>
          </div>
        )}

        {content.about_text_7 && (
          <div className="about-card">
            <p>{content.about_text_7}</p>
          </div>
        )}

        {content.about_text_8 && (
          <div className="about-card">
            <p>{content.about_text_8}</p>
          </div>
        )}

        {content.about_text_9 && (
          <div className="about-card">
            <p>{content.about_text_9}</p>
          </div>
        )}

        {content.about_text_10 && (
          <div className="about-card">
            <p>{content.about_text_10}</p>
          </div>
        )}
      </div>

      <div className="spacer" />
    </section>
  );
}